import React, { FC } from "react";
import { StyledPanel } from "./Panel.styles";

interface PanelProps {
  children: React.ReactNode;
  width?: string;
  marginTop?: string;
  marginBottom?: string;
  paddingTop?: string;
  top?: string;
  padding?: string;
}

const Panel: FC<PanelProps> = ({
  children,
  width,
  marginTop,
  marginBottom,
  paddingTop,
  top,
  padding,
}) => {
  return (
    <StyledPanel
      width={width}
      marginTop={marginTop}
      marginBottom={marginBottom}
      paddingTop={paddingTop}
      top={top}
      padding={padding}
    >
      {children}
    </StyledPanel>
  );
};

export default Panel;
